<template>
  <div class="anchor-options-style">
    <local-style
      class="template-styles"
      :options="options"
      :container_id="ids.container_id"
      :rect_id="ids.rect_id"
      elementType="cxAnchorComponent"
      :styleImgs="request_prefix === 'bigScreen' ? styleImages : styleImagesHome"
      @changeQuoteStyle="changeQuoteStyle"
      ref="localStyleComponent"
    />
  </div>
</template>

<script>
import defaultImage from "assets/images/default_image.png"
import localStyle from "toolbarComponents/styles/local-style.vue"
export default {
  name: "anchor-options-style",
  components: { localStyle },
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    }
  },
  data() {
    return {
      activeImgIndex: undefined,
      defaultImage: defaultImage,
      activeNames: [],
      showLen: 6,
      styleImages: [require("../assets/images/anchor1.png"), require("../assets/images/anchor2.png")],
      styleImagesHome: [require("../assets/images/anchor1.png"), require("../assets/images/anchor2.png")]
    }
  },
  methods: {
    showAllStyles() {
      this.$refs.localStyleComponent.showAllStyles()
    },
    changeQuoteStyle() {}
  }
}
</script>

<style lang="scss" scoped>
.anchor-styles {
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  .anchor-style-item {
    width: calc((100% - 32px) / 3);
    margin: 0 16px 16px 0;
    box-sizing: border-box;
    &:nth-child(3n) {
      margin-right: 0;
    }
    &.active {
      .anchor-style-box {
        border: 1px solid var(--themeColor);
        box-shadow: 0 0 0 1px var(--themeColor);
        .icon-checked {
          display: block;
        }
      }
    }
  }
  .anchor-style-box {
    position: relative;
    border-radius: 4px;
    margin-bottom: 8px;
    background-color: var(--styleBgColor);
    border: 1px solid #373737;
    overflow: hidden;
    img {
      width: 100%;
      height: 51px;
    }
    .icon-checked {
      position: absolute;
      right: 0;
      top: 0;
      width: 24px;
      height: 24px;
      background-image: url(../../../assets/images/icon-checked.png);
      background-size: 100% 100%;
      display: none;
    }
  }
  .anchor-item {
    border: none;
  }
}
</style>
